var Marionette = require('marionette'),
    Backbone = require('backbone'),
    Canvas = require('../canvas'),
    fvChannel = require('glRadio').channel('FV');


/**
 * Just a 'dummy page container' to wrap a canvas.
 * Necessary to set the canvas dimensions, which stretch to the size of it's
 * parent container.
 * Done in lieu of extending canvas module and setting dimensions on it directly, due
 * to current architecture involving the page-canvas channel.
 * Basically like an empty page view.
 * Debug mode is intended to be called from the console -- and SHOULD ONLY BE DONE in page mode to
 * ensure the rendered shape positions should match up correctly.
 * It should always be 0 in production
 */


var DEBUG_MODE = 0;

if (PRODUCTION) {
    DEBUG_MODE = 0;
}


module.exports = Marionette.ItemView.extend({

    initialize: function() {

        this.canvas = null;

    },

    render: function( vChannel, pageNumber, shapes ) {

        var pgCanvasChannel = new Backbone.Radio.Channel( 'pgCanvasChannel:p' + pageNumber );

        var docModePage =
            vChannel.request('activeDocPages').findWhere({ number: pageNumber });

        var pageModePage =
            vChannel.request('getNewFullPageModelFromDocModePage', docModePage);

        // Canvas expect a scale model -- it does many calculations from it.
        // In the future post a refactor, rendering everything non-transformed, this should no longer be necessary.
        var currentScaleModel =
            vChannel.request('pageViewScale');

        var clonedPageModeScale = currentScaleModel.clone();

        /**
         * If we're not in page mode, a 'derived scale' may not be set correctly because the
         * derived dimensions would be off -- this is because the DOM elements are hidden if we haven't entered
         * the mode yet when the page is loaded.
         * ( This is similar to the problem of going to page mode from doc mode after a F&R search is done for floating
         *  redactions when page mode hasn't loaded yet -- the box sizes and position would be incorrect ).
         * We could create a new scale model but making a clone is sufficient.
         * A clone vs directly modifying the page mode scale allows us to change the scale to a 'non derived' value,
         * without needed to set back the actual page mode scale values, which is problematic because we'd need to
         * somehow trigger a 'scale callback' event to update the changes in the rest of the views ( eg the scale value ).
         * Without doing this, if you save a spider redaction from document mode/pdf mode, the box positions will be calculated
         * incorrected for 'derived scale' values.
         * We set to a value of 1.0 -- which is fine for F&R (non-debug mode) where the canvas is hidden; BUT:
         * if trying to debug from the command line -- do it in PAGE MODE and set to the derived value to see the shapes as they
         * would appear over the page image.
         */

        if ( !DEBUG_MODE ) {
            clonedPageModeScale.setScale( pageModePage, 1.0, 'custom' );
        }

        var rotatedDimensions =
            pageModePage.getRotatedDimensionsWithScale( clonedPageModeScale.getScaleValue() );

        var cssToApply = {
            width: rotatedDimensions.width,
            height: rotatedDimensions.height
        };

        if ( DEBUG_MODE ) {

            cssToApply = _.extend( {}, cssToApply, {
                outline: '1px solid blue',
                position: 'fixed',
                top: 0,
                right: 0
            });

        } else {

            this.$el.addClass('offScreen');

        }

        this.$el.css( cssToApply );

        this.canvas = new Canvas({
            vChannel: vChannel,
            pageCanvasCh: pgCanvasChannel,
            page: pageModePage,
            scale: clonedPageModeScale // do it at the current scale to avoid problems -- I suppose you could try a new model at 1?
        });

        this.$el.append( this.canvas.canvasView.el );

        // First ensure canvas in DOM prior to render !
        $('body').append( this.el );

        // Call shape render when in DOM
        pgCanvasChannel.command( 'reRenderShapes', shapes );

        return this;

    },


    onBeforeDestroy: function() {

        this.canvas.destroy();

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/hiddenCanvas/view.js
 ** module id = 355
 ** module chunks = 0
 **/